module.exports = __webpack_public_path__ + "assets/img/1-1.4a9ce991.jpg";